import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from "./routes"
import Cookies from 'js-cookie'
import { getUserInfo, toSSOLogin } from '@/api/utils'
import { getQueryVariable } from '@/utils'
import { isPrivate } from '@/config'

export const whiteList = [/*'/login', */ '/common'];

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
 
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace (location) {
  return originalReplace.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const token = Cookies.get("JSESSIONID_StageNow");
  if(!isPrivate) { // 非私有化
    if(!token) { // 未登录
      let encryptInfo = getQueryVariable('encryptInfo'); // 获取浏览器参数
      if(encryptInfo) { // 存在encryptInfo
        getUserInfo(encryptInfo).then(response => !!response && next(to.path || '/'))
      }else{
        if(!whiteList.includes(to.path)) {
          toSSOLogin({redirect_url: process.env.BASE_URL + to.path})
        }else{
          next()
        }
      }
    } else {
      next()
    }
  }else{
    next()
  }
  // if(!isPrivate && !token && !whiteList.includes(to.path)) { // 未登录 + 非私有化 + 非公共页面
  //   // 获取后端重定向URL地址里面是否携带encryptInfo参数，如存在，则获取用户信息，否则跳转SSO登录页面
  //   let encryptInfo = getQueryVariable('encryptInfo'); // 获取浏览器参数
  //   encryptInfo? getUserInfo(encryptInfo).then(response => !!response && next(to.path || '/')) : toSSOLogin({redirect_url: process.env.BASE_URL + to.path});
  // } else {
  //   next();
  // }
})

export default router
